import { GET_DETAIL_ORDER, GET_LIST_ORDER, GET_USER_PROFILE } from './type';

export const initialState = {
  orders: {
    listOrder: [],
    total: 0,
  },
  detailOrder: null,
  userProfile: null,
};

export function ordersManagementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_ORDER:
      return {
        ...state,
        orders: {
          listOrder: action.payload.data.Details,
          total: action.payload.data.Summary.Total
        },
      };
    case GET_DETAIL_ORDER:
      return {
        ...state,
        detailOrder: action.payload.data
      };
    case GET_USER_PROFILE:
      return {
        ...state,
        userProfile: action.payload.data
      };
    default:
      return state;
  }
}
